export const GAME_ID = 'game-flappy-bird-rvn';

export const FLAPPY_BIRD_RAVEN = {
  utm_source: 'flappy_bird_rvn',
};
